// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as FastAverageColor from "fast-average-color";
function getColor(img) {
  try {
    return Belt_Option.map(Caml_option.nullable_to_opt(new FastAverageColor.FastAverageColor().getColor(img)), function (result) {
      return result.hex;
    });
  } catch (exn) {
    return;
  }
}
export { getColor };
/* fast-average-color Not a pure module */